import {connect} from '../../app/connect';
import IssueTypeSelectDropdown from '../common/IssueTypeSelectDropdown';
import {
  getActiveIssueSubTypesGroupedDropdownOptionsWithLabelValueMap,
  getIssueSubTypesGroupedDropdownOptionsWithLabelValueMapIncludingCurrent,
  getIssueTypesAdminEntitiesMapWithLabelValueMap,
  getSelectedSubtypeWithLabelAndValue
} from '../../app/selectors';

const getIssueTypeSelectDropdownValuesIncludingCurrent = (state, selectedOptionId) => {
  const selectedSubtype = getSelectedSubtypeWithLabelAndValue(state, selectedOptionId);
  if (selectedSubtype && !selectedSubtype.isActive) {
    return getIssueSubTypesGroupedDropdownOptionsWithLabelValueMapIncludingCurrent(state, selectedOptionId);
  }
  return getActiveIssueSubTypesGroupedDropdownOptionsWithLabelValueMap(state);
};

const mapStateToProps = (state, ownProps) => ({
  activeIssueSubTypesGroupedDropdownOptions: getIssueTypeSelectDropdownValuesIncludingCurrent(
    state,
    ownProps.selectedOptionId
  ),
  fieldIssueTypeEntitiesMap: getIssueTypesAdminEntitiesMapWithLabelValueMap(state)
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueTypeSelectDropdown);
